import { marshal, Nullable, PastProjectItem } from "@gsx/common";
import { injectable } from "inversify";
import { EditStore } from "../../general/EditStore";
import { createPastProjectEmptyBody } from "../../../utility/entity/pastProject";
import { Api } from "../../../../../common/src/api/Api";

@injectable()
export class PastProjectEditStore extends EditStore<PastProjectItem> {
    private id: string = "";
    readonly data: Nullable<PastProjectItem> = createPastProjectEmptyBody();

    constructor(private readonly api: Api) {
        super();
    }

    public setId(value: string): void {
        this.id = value;
    }

    protected async loadRequest(): Promise<PastProjectItem> {
        return this.api.admin.pastProject.get(this.id);
    }

    protected async updateRequest(): Promise<void> {
        const body = marshal(this.data);
        await this.api.admin.pastProject.update(this.id, body);
    }
}
